export default __webpack_public_path__ + "static/media/bootstrap.min.js.0d6da5e4.map";